// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Box, Grid, CircularProgress, Typography } from "@mui/material";
// import DOMPurify from "dompurify"; // for security — prevents XSS attacks
// import { useParams,useLocation } from "react-router-dom";
// import SidebarMenu from "./SidebarMenu";
// import Header from "./Header";

// const StoryDetail = () => {
//     // const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");

//    const { year, month,issue } = useParams(); // 👈 get year & month from URL
//       const { state } = useLocation();
//       const data = state?.story;
//     //  const { data } = location.state || {};
//       console.log("location data", data)

//     // useEffect(() => {
//     //     const fetchImages = async () => {
//     //          setLoading(true);
//     //         try {
//     //             const res = await axios.get(`${BASE_URL}api/inside-pages?year=${year}&month=${month}`);
//     //             //    const res = await axios.get("/api/inside-pages");
//     //             console.log("API response", res)
//     //             setData(res?.data?.data ? res?.data?.data : []);
//     //         } catch (err) {
//     //             console.error(err);
//     //             setError("Failed to load images.");
//     //         } finally {
//     //             setLoading(false);
//     //         }
//     //     };

//     //     fetchImages();
//     // }, [year,month,issue]);



//     // if (loading) {
//     //     return (
//     //         <Box display="flex" justifyContent="center" py={6}>
//     //             <CircularProgress />
//     //         </Box>
//     //     );
//     // }

//     if (error) {
//         return (
//             <Typography color="error" align="center" py={4}>
//                 {error}
//             </Typography>
//         );
//     }

//     // const stripHtml = (html) => {
//     //     const tempDiv = document.createElement("div");
//     //     tempDiv.innerHTML = html;
//     //     return tempDiv.textContent || tempDiv.innerText || "";
//     // };

//     // Utility function to remove all HTML tags, scripts, and CSS
//     const stripHtml = (html) => {
//         // Create a temporary element
//         const tempDiv = document.createElement("div");
//         tempDiv.innerHTML = html;

//         // Remove <style> and <script> tags
//         const styles = tempDiv.querySelectorAll("style, script");
//         styles.forEach((el) => el.remove());

//         // Get text content only
//         return tempDiv.textContent || tempDiv.innerText || "";
//     };

//     const HtmlContentRenderer = ({ htmlContent }) => {
//         // Sanitize HTML before rendering
//         const cleanHtml = DOMPurify.sanitize(htmlContent, {
//             ADD_TAGS: ["style"],
//             ADD_ATTR: ["target"],
//         });

//         return (

//             <Box
//                 sx={{
//                     mt: 3,
//                     mb: 5,
//                     px: { xs: 2, sm: 4, md: 6 },
//                     "& img": {
//                         borderRadius: "8px",
//                         maxWidth: "100%",
//                         height: "auto",
//                     },
//                     "& a": {
//                         textDecoration: "none !important", // 🔥 removes underline
//                         // color: "inherit", // keeps text color same as surrounding text
//                     },
//                     "& a:hover": {
//                         textDecoration: "none !important", // also remove on hover
//                     },
//                 }}
//                 dangerouslySetInnerHTML={{ __html: cleanHtml }}
//             />
//         );
//     };




//     console.log("data", data)
//     return (

//         <Box py={4} px={{ xs: 2, sm: 4, md: 8 }}>
//             <Grid container spacing={3} justifyContent="center">
//                 {data?.items?.map((item) => {
//                     const imageUrl = item.field_banner_image ? item?.field_banner_image : null;
//                     return (
//                         imageUrl && (
//                             <Grid item key={item.id} xs={12} sm={6} md={4} lg={3}>
//                                 <Box
//                                     sx={{
//                                         position: "relative",
//                                         width: "100%",
//                                         borderRadius: 2,
//                                         overflow: "hidden",
//                                         boxShadow: 2,
//                                         "&:hover": { transform: "scale(1.03)" },
//                                         transition: "transform 0.3s ease",
//                                     }}
//                                 >
//                                     {/* Background Image */}
//                                     <Box
//                                         component="img"
//                                         src={imageUrl}
//                                         alt={item.title || "Echo Inside Page"}
//                                         sx={{
//                                             width: "100%",
//                                             height: "auto",
//                                             display: "block",
//                                         }}
//                                     />

//                                     {/* Overlay gradient (optional, for readability) */}
//                                     <Box
//                                         sx={{
//                                             position: "absolute",
//                                             top: 0,
//                                             left: 0,
//                                             width: "100%",
//                                             height: "100%",
//                                             background:
//                                                 "linear-gradient(to bottom, rgba(0,0,0,0.2) 20%, rgba(0,0,0,0.6) 100%)",
//                                         }}
//                                     />

//                                     {/* Overlay Text */}
//                                     <Box
//                                         sx={{
//                                             position: "absolute",
//                                             bottom: 20,
//                                             left: "50%",
//                                             transform: "translateX(-50%)",
//                                             color: "white",
//                                             textAlign: "center",
//                                             width: "90%",
//                                         }}
//                                     >
//                                         {/* Topic text like #MahindraRise */}
//                                         {item?.field_topic && (
//                                             <Typography
//                                                 variant="h6"
//                                                 sx={{
//                                                     fontWeight: 600,
//                                                     fontSize: { xs: "1rem", md: "1.2rem" },
//                                                     position: "relative",
//                                                     display: "inline-block",
//                                                     mb: 0.5,
//                                                     "&::before": {
//                                                         content: '""',
//                                                         position: "absolute",
//                                                         bottom: 0,
//                                                         left: 0,
//                                                         width: "30px",
//                                                         height: "2px",
//                                                         // backgroundColor: "#e4002b", // Mahindra red underline
//                                                         transform: "translateY(4px)",
//                                                     },
//                                                 }}
//                                             >
//                                                 {item.field_topic}
//                                             </Typography>
//                                         )}

//                                         {/* Page Title */}
//                                         {item?.title && (
//                                             <Typography
//                                                 variant="h5"
//                                                 sx={{
//                                                     fontWeight: 600,
//                                                     fontSize: { xs: "1.1rem", md: "1.4rem" },
//                                                     lineHeight: 1.3,
//                                                     mt: 0.5,
//                                                 }}
//                                             >
//                                                 {item.title}
//                                             </Typography>
//                                         )}
//                                     </Box>
//                                 </Box>
//                                 {/* {item?.field_description && (
//                                     <Typography
//                                         variant="body1"
//                                         sx={{
//                                             textAlign: "justify",
//                                             color: "text.primary",
//                                             fontSize: { xs: "0.95rem", md: "1.05rem" },
//                                             lineHeight: 1.8,
//                                             letterSpacing: "0.02em",
//                                             fontWeight: 400,
//                                             mt: 2,
//                                             mb: 3,
//                                             px: { xs: 1, sm: 3, md: 6 }, // adds side padding for readability
//                                             fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
//                                         }}
//                                     >
//                                         {stripHtml(item.field_description)}
//                                     </Typography>
//                                 )} */}
//                                 {/* <Typography
//                                     variant="body2"
//                                     dangerouslySetInnerHTML={{ __html: item.field_description }}
//                                 /> */}

//                                 {item?.field_description && (
//                                     <HtmlContentRenderer htmlContent={item.field_description} />
//                                 )}
//                             </Grid>
//                         )
//                     );
//                 })}
//             </Grid>
//         </Box>



//     );
// };

// export default StoryDetail;




/////old code 

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Box, Grid, CircularProgress, Typography } from "@mui/material";
// import DOMPurify from "dompurify"; // for security — prevents XSS attacks
// import { useParams, useLocation } from "react-router-dom";
// import SidebarMenu from "./SidebarMenu";
// import Header from "./Header";

// const StoryDetail = () => {
  
//     const location = useLocation();
//       const data = location?.state?.story;
//      const allStories = location?.state?.data || [];
  
//     console.log("location data", data)

//     // const stripHtml = (html) => {
//     //     const tempDiv = document.createElement("div");
//     //     tempDiv.innerHTML = html;
//     //     return tempDiv.textContent || tempDiv.innerText || "";
//     // };

//     // Utility function to remove all HTML tags, scripts, and CSS
//     const stripHtml = (html) => {
//         // Create a temporary element
//         const tempDiv = document.createElement("div");
//         tempDiv.innerHTML = html;

//         // Remove <style> and <script> tags
//         const styles = tempDiv.querySelectorAll("style, script");
//         styles.forEach((el) => el.remove());

//         // Get text content only
//         return tempDiv.textContent || tempDiv.innerText || "";
//     };

//  const HtmlContentRenderer = ({ htmlContent }) => {
//     // Sanitize HTML before rendering
//     const cleanHtml = DOMPurify.sanitize(htmlContent, {
//         ADD_TAGS: ["style"],
//         ADD_ATTR: ["target"],
//     });

//     return (
//         <Box
//             sx={{
//                 mt: 3,
//                 mb: 5,
//                 maxWidth: "700px",         // ✅ Keeps content in a readable width (like screenshot 71)
//                 mx: "auto",                // ✅ Centers horizontally
//                 px: { xs: 2, sm: 3, md: 0 }, // ✅ Removes extra side padding at large screens
//                 fontFamily: "'OpenSans-Regular'",
//                 fontSize: "16px",
//                 lineHeight: "1.6",
//                 color: "#000",

//                 "& img": {
//                     width: "100%",
//                     height: "auto",
//                 },
//                 "& a": {
//                     textDecoration: "none !important",
//                     color: "inherit",
//                 },
//                 "& a:hover": {
//                     textDecoration: "none !important",
//                 },
//                 "& p": {
//                     mb: 2,
//                 },
//             }}
//             dangerouslySetInnerHTML={{ __html: cleanHtml }}
//         />
//     );
// };


//     return (
//         <Box py={4} px={{ xs: 2, sm: 4, md: 8 }}   sx={{marginTop:"-4.2%" }}>
//             <Grid container spacing={3} justifyContent="center">
//                 {[data]?.map((item) => {
//                     const imageUrl = item.field_banner_image ? item?.field_banner_image : null;
//                     return (
//                         imageUrl && (
//                             <Grid item key={item.id} xs={12} sm={6} md={4} lg={3}>
//                                 <Box
//                                     sx={{
//                                         position: "relative",
//                                         width: "100%",
//                                         overflow: "hidden",
//                                         boxShadow: 2,
//                                     }}
//                                 >
//                                     {/* Background Image */}
//                                     <Box
//                                         component="img"
//                                         src={imageUrl}
//                                         alt={item.title || "Echo Inside Page"}
//                                         sx={{
//                                             width: "100%",
//                                             height: "auto",
//                                             display: "block",
//                                         }}
//                                     />

//                                     {/* Overlay gradient (optional, for readability) */}
//                                     <Box
//                                         sx={{
//                                             position: "absolute",
//                                             top: 0,
//                                             left: 0,
//                                             width: "100%",
//                                             height: "100%",
//                                             background:
//                                                 "linear-gradient(to bottom, rgba(0,0,0,0.2) 20%, rgba(0,0,0,0.6) 100%)",
//                                         }}
//                                     />

//                                     {/* Overlay Text */}
//                                     <Box
//                                         sx={{
//                                             position: "absolute",
//                                             bottom: 20,
//                                             left: "50%",
//                                             transform: "translateX(-50%)",
//                                             color: "white",
//                                             textAlign: "center",
//                                             width: "90%",
//                                         }}
//                                     >
//                                         {/* Topic text like #MahindraRise */}
//                                         {item?.field_topic && (
//                                             <Typography      
//                                                 sx={{
//                                                     fontFamily: "'DancingScript-Regular', cursive",
//                                                     fontSize: "25.6px",
//                                                     fontWeight: 700,
//                                                     //  textAlign: "left",
//                                                 }}
//                                             >
//                                                 {item.field_topic}
//                                             </Typography>
//                                         )}

//                                         {/* Page Title */}
//                                         {item?.title && (
//                                             <Typography
//                                                 // variant="h5"
//                                                 // sx={{
//                                                 //     fontWeight: 600,
//                                                 //     fontSize: { xs: "1.1rem", md: "1.4rem" },
//                                                 //     lineHeight: 1.3,
//                                                 //     mt: 0.5,
//                                                 // }}

//                                                 sx={{

//                                                     // textAlign: "left",
//                                                     fontFamily: "'OpenSans-Regular'",
//                                                     fontSize: "1.6rem",
//                                                     fontWeight: 400,
//                                                     lineHeight: "1.6rem",
//                                                     fontSize:"32px"

//                                                 }}
//                                             >
//                                                 {item.title}
//                                             </Typography>
//                                         )}
//                                     </Box>
//                                 </Box>
                                
//                                  {item?.field_intro_inside_page && (
//                                     <HtmlContentRenderer htmlContent={item.field_intro_inside_page} />
//                                 )}

//                                 {item?.field_description && (
//                                     <HtmlContentRenderer htmlContent={item.field_description} />
//                                 )}
//                             </Grid>
//                         )
//                     );
//                 })}
//             </Grid>
//         </Box>



//     );
// };

// export default StoryDetail;




import React, { useEffect, useRef, useState } from "react";
import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GmailLogin from "./GmailLogin";
import CommentSection from "./CommentSection";
import ActionSidebar from "./ActionSidebar";
import SeoMeta from "./SeoMeta";
import axios from "axios";
import { BASE_URL } from "../config/network/ApiUrl";

const StoryDetail = () => {
  const { year, month, issue ,title} = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [commentCountData, setCommentCountData] = useState({});
  const [showSidebar, setShowSidebar] = useState(false);
  // const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentStory, setCurrentStory] = useState({});
  const [index, setIndex] = useState(0);
  const [allStories, setAllStories] = useState([]);

  console.log("year in story detail",year,"month",month,"issue",issue,"title",title)
  const commentRef = useRef();
  const loginRef = useRef();  
//   const data = location?.state?.story;
//   const allStories = location?.state?.data || [];

//   const currentIndex = allStories?.findIndex((s) => s?.id === data?.id);
// //   const [index, setIndex] = useState(currentIndex >= 0 ? currentIndex : 0);
//    const index = currentIndex >= 0 ? currentIndex : 0;

//   const currentStory = allStories[index];
//   console.log("currentStory",currentStory)
//   console.log("user info",user)
//   console.log("allStories",allStories,"data",data,"index",index,"currentIndex",currentIndex)

  const formatTitle = (title) => {
  return title
    .replace(/-/g, " ")   // replace hyphens with spaces
    .toUpperCase();       // convert to uppercase
};

  
  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}api/inside-pages?year=${year}&month=${month}&issue_number=${issue.split("-")[1]}`);

        const formattedTitle = formatTitle(title);
        const allStories = res?.data?.data.items;      
        const currentIndex = allStories?.findIndex((s) =>formatTitle(s?.title) === formattedTitle);
        const index = currentIndex >= 0 ? currentIndex : 0;
        const currentStory = allStories[index];
        setIndex(index)
        setCurrentStory(currentStory)
        setAllStories(allStories)
        console.log("API response in StoryDetail",  res)
        console.log("formattedTitle",  formattedTitle)
        console.log("currentStory",  currentStory)
        console.log("currentIndex above",  currentIndex,"index",index)
         console.log("allStories",  allStories)
      } catch (err) {
        console.error(err);
        setError("Failed to load images.");
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [year, month, issue,title]);


   // ✅ Auto-login from localStorage
  useEffect(() => {   
    const savedUser = localStorage.getItem("userData");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);
useEffect(() => {
  // 👉 Mobile view: Always visible, no scroll logic
  if (window.innerWidth < 900) {
    setShowSidebar(true);
    return;
  }

  // 👉 Desktop view: scroll-based visibility
  let lastScroll = window.scrollY;

  const handleScroll = () => {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll + 10) {
      // scrolling down
      setShowSidebar(true);
    } else if (currentScroll < lastScroll - 10) {
      // scrolling up
      setShowSidebar(false);
    }

    lastScroll = currentScroll;
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);

}, []);



  // const handlePrev = () => {
  //   if (index > 0) {
  //     const prevStory = allStories[index - 1];
  //     //  setCurrentStory(prevStory)
  //     const slug = prevStory?.title?.toLowerCase().replace(/\s+/g, "-");
  //     const url = `/${prevStory?.issue_info?.full_issue}/${slug}`;
  //     navigate(url, { state: { story: prevStory, data: allStories } });
  //     // window.location.reload(); // full reload to match Mahindra Echo behavior
  //   }
  // };

  // const handleNext = () => {
  //   if (index < allStories.length - 1) {
  //     const nextStory = allStories[index + 1];
  //     // setCurrentStory(nextStory)
  //     const slug = nextStory?.title?.toLowerCase().replace(/\s+/g, "-");
  //     const url = `/${nextStory?.issue_info?.full_issue}/${slug}`;
  //     navigate(url, { state: { story: nextStory, data: allStories } });
  //     // window.location.reload(); // full reload to match Mahindra Echo behavior
  //   }
  // };

    const handlePrev = () => {
    if (index > 0) {
      
      const prevStory = allStories[index - 1];
      //  setCurrentStory(prevStory)
      const slug = prevStory?.title?.toLowerCase().replace(/\s+/g, "-");
      const url = `/${prevStory?.issue_info?.full_issue}/${slug}`;
      navigate(url, { state: { story: prevStory, data: allStories } });
      // window.location.reload(); // full reload to match Mahindra Echo behavior
    }
  };

  const handleNext = () => {
    if (index < allStories.length - 1) {
      const nextStory = allStories[index + 1];
      // setCurrentStory(nextStory)
      const slug = nextStory?.title?.toLowerCase().replace(/\s+/g, "-");
      const url = `/${nextStory?.issue_info?.full_issue}/${slug}`;
      navigate(url, { state: { story: nextStory, data: allStories } });
      // window.location.reload(); // full reload to match Mahindra Echo behavior
    }
  };

  const HtmlContentRenderer = ({ htmlContent }) => {
    const cleanHtml = DOMPurify.sanitize(htmlContent, {
      ADD_TAGS: ["style"],
      ADD_ATTR: ["target"],
    });

    return (
      <Box
        sx={{
          mt: 3,
          mb: 5,
          maxWidth: "700px",
          mx: "auto",
          px: { xs: 2, sm: 3, md: 0 },
          fontFamily: "OpenSans-Regular",
          fontSize: "16px",
          lineHeight: "24px",
          color: "#000",
          "& img": {
            width: "100%",
            height: "auto",
          },
          "& a": {    
           color: "#e31837", 
           textDecoration: "none",
          },
          "& a:hover": {
            textDecoration: "none",
          },
          "& p": {
            mb: 2,
          },
     /* 🔴 ADD RED DOT BEFORE EACH <li> */
        "& li": {
          position: "relative",
          listStyle: "none",
          paddingLeft: "18px",
          marginBottom: "8px",
        },
        "& li::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: "9px",
          width: "7px",
          height: "7px",
          backgroundColor: "#dc042b", 
          borderRadius: "50%",
        },
       
        }}
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
    );
  };

  if (!currentStory) return null;
  const imageUrl = currentStory.field_banner_image || "";

  return (
    <>  
    {/* Dynamic Meta Tags */}
     <SeoMeta data={currentStory} />
    <Container className="mobileNoPadding" sx={{ marginTop: "5.8%" , width: "100%",
                                        height: "auto",
                                        padding:"0px !important",
                                        maxWidth: "-webkit-fill-available", }}  >
      <Grid container style={{padding:"0px !important",}}>
        <Grid item xs={12} style={{padding:"0px !important",width:"100%"}}>
          {/* ===== Banner Section ===== */}
          <Box
            sx={{
              position: "relative",
              width: "100%",
              overflow: "hidden",
              // boxShadow: 2,
              maxWidth: "-webkit-fill-available", 
            }}
          >
            {/* Background Image */}
            <Box
              component="img"
              src={imageUrl}
              alt={currentStory.title || "Echo Inside Page"}  
              sx={{
                width: "100%",
                height: "auto",
                maxWidth:"100%",
                display: "block",
              }}
            />

  {/* Top dark fade */}
  {/* <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "50%",
      background:
        "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0))",
      zIndex: 1,
    }}
  /> */}

{/* Bottom subtle fade */}
<Box
  sx={{
    position: "absolute",
    bottom: 0,
    right: 0,
    left: 0,
    minHeight: "44%",   // smaller height → subtle fade
      background:
      "linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(127, 127, 127, 0.95) 81%)",
  }}
/>

     
    {/* Overlay Text */}
  <Box
  className="hideInmobile"
   sx={{
    position: "absolute",
    bottom: "4%",
    // marginBottom:".5rem",
    left: "17%",        
    textAlign: "left", 
    width: "fit-content",
    maxWidth: "65%",
    display: "block",         
    animation: "slideUp 1.2s ease-out forwards",
    "@keyframes slideUp": {
      "0%": {
        transform: "translateY(80px)",
        opacity: 0,
      },
      "100%": {
        transform: "translateY(0)",
        opacity: 1,
      },
    },
  }}
>
  {/* Topic */}
  {currentStory?.field_topic && (
    <Typography
      sx={{
        fontFamily: "'DancingScript-Regular'",
        fontSize: "25.6px",
        fontWeight: 700,
        mb: 2, // spacing between topic & title
        color:"#ffffff",
        lineHeight:"25.6px"
      }}
    >
      {currentStory.field_topic}
    </Typography>
  )}

  {/* Page Title */}
  {currentStory?.title && (
    <Typography
      sx={{
        fontFamily: "'OpenSans-Regular'",
        fontSize: "32px",
        fontWeight: 500,
        lineHeight: 1.2,
        color:"#ffffff",
        // width: "75%",
      }}
    >
      {currentStory.title}
    </Typography>
  )}
</Box>

          </Box>
{showSidebar && (
  <ActionSidebar
    onComment={() => {
    if (user) {
     commentRef.current.focusCommentBox();
    } else {
      loginRef.current?.scrollIntoView({  
        behavior: "auto",
      });
      loginRef.current?.focus();
    }
  }}
  commentCountData={commentCountData}
  />
)}

          {/* ===== Prev / Next Story Buttons (outside banner) ===== */}
         {/* ===== Prev Story Button ===== */}
       <div className="visibleMobile mobilePadding">
          {currentStory?.field_topic && (
    <Typography
      sx={{
        fontFamily: "'DancingScript-Regular'",
        fontSize: "25.6px",
        fontWeight: 700,
        mb: 2, // spacing between topic & title
        color:"#000",
        lineHeight:"25.6px",
        mt:4
      }}
    >
      {currentStory.field_topic}
    </Typography>
  )}
          {currentStory?.title && (
    <Typography
      sx={{
        fontFamily: "'OpenSans-Regular'",
        fontSize: "32px",
        fontWeight: 500,
        lineHeight: 1.2,
        color:"#000",
        // width: "75%",
      }}
    >
      {currentStory.title}
    </Typography>
  )}
  </div>
{index > 0 && (
  <Box
    onClick={handlePrev}
    sx={{
      position: "fixed",  
      top: { xs: "auto", md: "50%" },
      bottom: { xs: "2%", md: "auto" },
      left: { xs: "0%", md: "2px" },
      transform: { xs: "none", md: "translateY(-50%)" },
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: { xs: "3px", md: "5px" },
      zIndex: 1000,
      "&:hover": { color: "#d32f2f" },
      backgroundColor: { xs: "rgba(255, 255, 255, 0.9)", md: "transparent" },
      padding: { xs: "8px 12px", md: "0" },
      //borderRadius: { xs: "20px", md: "0" },
      boxShadow: { xs: "0 2px 8px rgba(0,0,0,0.2)", md: "none" },
    }}
  >
    <Typography
      sx={{
        fontFamily: "'OpenSans-Regular'",
        fontSize: { xs: "18px", md: "20px" },
        lineHeight:{xs:"0.2", md:"1"},
        color: { xs: "#000", md: "inherit" }
      }}
    >
      ❮
    </Typography>
    <Box sx={{ 
      lineHeight: {xs:"0.2", md:"1.2"},
      display: {sm: "block" } 
    }}>
      <Typography
        sx={{
          fontFamily: "'OpenSans-Regular'",
          fontSize: { xs: "0.625rem", md: "0.625rem" },
          letterSpacing: { xs: "0.5px", md: "1px" },
          textTransform: "uppercase",
          color: { xs: "#000", md: "inherit" }
        }}
      >
        Prev
      </Typography>
      <Typography
        sx={{
          fontFamily: "'OpenSans-Regular'",
          fontSize: { xs: "0.625rem", md: "0.625rem" },
          lineHeight:{xs:"0.2", md:"1"},
          letterSpacing: { xs: "0.5px", md: "1px" },
          textTransform: "uppercase",
          color: { xs: "#000", md: "inherit" }
        }}
      >
        Story
      </Typography>
    </Box>
  </Box>
)}

{/* ===== Next Story Button ===== */}
{index < allStories.length - 1 && (
  <Box
    onClick={handleNext}
    sx={{
      position: "fixed",  
      top: { xs: "auto", md: "50%" },
      bottom: { xs: "2%", md: "auto" },
      right: { xs: "0%", md: "2px" },
      transform: { xs: "none", md: "translateY(-50%)" },
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: { xs: "3px", md: "5px" },
      zIndex: 1000,
      "&:hover": { color: "#d32f2f" },
      backgroundColor: { xs: "rgba(255, 255, 255, 0.9)", md: "transparent" },
      padding: { xs: "8px 12px", md: "0" },
      //borderRadius: { xs: "20px", md: "0" },
      boxShadow: { xs: "0 2px 8px rgba(0,0,0,0.2)", md: "none" },
    }}
  >
    <Box sx={{ 
      textAlign: "left", 
      lineHeight: "1.2",
      display: { sm: "block" } 
    }}>
      <Typography
        sx={{
          fontFamily: "'OpenSans-Regular'",
          fontSize: { xs: "0.625rem", md: "0.625rem" },
          letterSpacing: { xs: "0.5px", md: "1px" },
          textTransform: "uppercase",
          lineHeight:{xs:"1", md:"1"},
          color: { xs: "#000", md: "inherit" }
        }}
      >
        Next
      </Typography>
      <Typography
        sx={{
          fontFamily: "'OpenSans-Regular'",
          fontSize: { xs: "0.625rem", md: "0.625rem" },
          letterSpacing: { xs: "0.5px", md: "1px" },
          lineHeight:{xs:"1", md:"1.2"},
          textTransform: "uppercase",
          color: { xs: "#000", md: "inherit" }
        }}
      >
        Story
      </Typography>
    </Box>
    <Typography
      sx={{
        fontFamily: "'OpenSans-Regular'",
        fontSize: { xs: "18px", md: "20px" },
        lineHeight:{xs:"1", md:"1"},
        color: { xs: "#000", md: "inherit" }
      }}
    >
      ❯
    </Typography>
  </Box>
)}


          {/* ===== Story Content Section ===== */}
          {/* {currentStory?.field_intro_inside_page && (
            <HtmlContentRenderer
              htmlContent={currentStory.field_intro_inside_page}
            />
          )} */}

          {currentStory?.field_description && (
            <HtmlContentRenderer htmlContent={currentStory.field_description} />
          )}
        </Grid>
      </Grid>
    </Container>

   
           <Box
                sx={{
                    width: "100%",
                    maxWidth: "700px",   // ⬅️ Increased width
                    margin: "0 auto",
                    mt: {md:4,xs:-4},
                    marginTop:"-3.2%",
                    mb:{xs:-3}
                }}
            >
     {/* Top Info Box */}
            <Paper
                elevation={0}
                sx={{
                    backgroundColor: "#f2f2f2",
                    padding: "12px 18px",
                    borderRadius: 0,
                }}
                className="commentSec"
            >
                <Typography sx={{ fontSize: "16px",fontFamily:"'OpenSans-Regular'",fontWeight: 595}}>
                    <span style={{ color: "#dc042b",  }}>Enjoyed this story?</span>{" "}
                    Hit the <span style={{ color: "#dc042b"}}>Like</span> button to let us know! <br />
                    You can also share your thoughts in the{" "}
                    <span style={{ color: "#dc042b" }}>Comments</span> section below!
                </Typography>
            </Paper>
            </Box>
            <br></br>
          

     {!user ? (
       <GmailLogin setUser={setUser} ref={loginRef}/>
      ) : (
        <CommentSection user={user} currentStory={currentStory} commentRef={{ commentRef  }} setCommentCountData={setCommentCountData}/>
      )}
    </>
  );
};

export default StoryDetail;








